import LanguageModel from './LanguageModel';
import translateWithComponent from './translateWithComponent';

const languageModel = new LanguageModel({
    getLangPath: (name) => (`${process.env.PUBLIC_URL}/languages/${name}.json`)
});

const concat = languageModel.concat;
const translate = translateWithComponent(languageModel.translate);
const isRtl = languageModel.isRtl;
const isCurrentLanguageRTL = languageModel.isCurrentLanguageRTL;
const currentLanguageDirection = languageModel.currentLanguageDirection;

export {
    concat,
    languageModel,
    isRtl,
    isCurrentLanguageRTL,
    currentLanguageDirection,
    translate as default,
};



// WEBPACK FOOTER //
// ./src/helpers/LanguageModel/index.js